export default "__VITE_ASSET__B0GtvU_G__"